/**
 * Setup scheduled job actions (extensible).
 * Keys are stored on the scheduler row (action_type / scheduler_type) and in config.scheduledAction.
 */
export const SCHEDULED_JOB_ACTIONS = [
  {
    value: 'custom_script',
    label: 'Custom Script',
    description: 'Run a backend custom script on schedule',
  },
];

export const DEFAULT_SCHEDULED_JOB_ACTION = 'custom_script';

export function getScheduledJobAction(value) {
  return SCHEDULED_JOB_ACTIONS.find((a) => a.value === value) || null;
}

export function scheduledJobActionLabel(value) {
  const a = getScheduledJobAction(value);
  if (a) return a.label;
  if (value === 'custom_script') return 'Custom Script';
  return value || '—';
}

/** True when this row is a Setup-created custom script job (editable in Scheduled Jobs). */
export function isCustomScriptJob(row) {
  if (!row) return false;
  if (row.scheduler_type === 'custom_script') return true;
  if (row.action_type === 'run_custom_script') return true;
  try {
    let c = row.config;
    if (typeof c === 'string') c = JSON.parse(c);
    if (c && typeof c === 'object') {
      if (c.scheduledAction === 'custom_script') return true;
      if (c.customScriptId || c.custom_script_id) return true;
    }
  } catch (_) {
    /* ignore */
  }
  return false;
}
